<template>
  <modal ref="businessmodelsmodalref">
    <div slot="title"><translate>Business modely</translate></div>
    <div slot="body">
      <ul>
        <li v-for="businessModel in businessModels" :key="businessModel.id">
          <router-link :to="{ name: 'businessModelsDetail', params: { id: businessModel.id } }">{{ businessModel.name }}</router-link>
        </li>
      </ul>
    </div>
  </modal>
</template>

<script>
export default {
  name: 'BusinessModelsModal',
  data: function () {
    return {
      businessModels: null,
    }
  },
  methods: {
    showBusinessModels(businessModels) {
      this.businessModels = businessModels;
      if(businessModels && businessModels.length > 0) {
        this.$refs.businessmodelsmodalref.showModal(true)
      }
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/common/BusinessModelsModal.vue